import { Helmet } from 'react-helmet';

import styles from './EditForm.style';
import Configure from './embed/Configure';
import AddField from './fields/AddField';
import EditField from './fields/EditField';
import ListFields from './fields/ListFields';
import FormToggles from './FormToggles';

class EditForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedFieldIndex: -1,
    };
  }

  setSelectedFieldIndex = (selectedFieldIndex) => {
    this.setState({ selectedFieldIndex });
  };

  onChangeField = (field, shouldDelete = false) => {
    let { form } = this.props;

    let fields = form.fields.slice(0);
    let fieldIndex;

    if (!field.id) {
      fieldIndex = this.state.selectedFieldIndex;
    } else {
      fieldIndex = fields.findIndex((f) => f.id === field.id);
    }

    if (shouldDelete) {
      fields.splice(fieldIndex, 1);
    } else {
      fields.splice(fieldIndex, 1, field);
    }

    this.onChangeFields(fields);
  };

  onChangeFields = (fields) => {
    let { form } = this.props;
    form = Object.assign({}, form, { fields: fields });
    this.props.onChange(form, true);
  };

  addField = (field) => {
    let { form } = this.props;
    let fields = form.fields.slice(0);
    fields.push(field);

    this.onChangeFields(fields);
    this.setSelectedFieldIndex(fields.length - 1);
  };

  closeForm = () => {
    this.setState({ selectedFieldIndex: -1 });
  };

  render() {
    const { selectedFieldIndex } = this.state;
    const { classes, form, onRefreshForm } = this.props;

    const selectedField = form.fields[selectedFieldIndex];

    return (
      <div className={classes.root}>
        <Helmet>
          <title>{`${form.name}`}</title>
        </Helmet>
        <div className={classes.lhc}>
          <div className={classes.header}>
            <FormToggles form={form} />

            <div className={classes.spacer} />

            <AddField form={form} addField={this.addField} />
          </div>

          <ListFields
            fields={form.fields}
            onChange={this.onChangeFields}
            selectedFieldIndex={selectedFieldIndex}
            onSelectFieldIndex={this.setSelectedFieldIndex}
          />
        </div>

        <div className={classes.rhc}>
          {selectedField ? (
            <EditField
              field={selectedField}
              fields={form.fields}
              onChange={this.onChangeField}
              onRefreshForm={onRefreshForm}
              onClose={this.closeForm}
            />
          ) : (
            <Configure
              key={form.id}
              form={form}
              onChange={this.props.onChange}
            />
          )}
        </div>

        <div className={classes.background} />
      </div>
    );
  }
}

EditForm.propTypes = {
  classes: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onRefreshForm: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default withStyles(styles)(EditForm);
